import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useVPNStatus } from '../../hooks/useVPNStatus';
import Information from '../Information/Information';

export default memo(function VPNStatus(props) {
    const [t] = useTranslation(['common', 'dashboard']);

    useVPNStatus(props.getSupportConnectionRequest);

    const setTitle = () => {
        if (props.supportConnection.vpnStatus === 'ok' && props.supportConnection.ip) {
            return props.supportConnection.ip;
        } else if (props.supportConnection.connecting) {
            return `${t('dashboard:connecting')}...`;
        } else {
            return t('dashboard:connect');
        }
    };

    return <Information
        actionTitle={setTitle()}
        error={props.supportConnection.connectionError}
        errorDescription={t('dashboard:update_error')}
        fetching={props.supportConnection.connecting}
        ip
        icon="./icons/life_vest.svg"
        onClick={props.connectToSupportVPNRequest}
        showAction={!props.supportConnection.ip}
        success={props.supportConnection.ip}
        title={t('dashboard:vpn_status')}
        value={props.supportConnection.ip}
        warning={!props.supportConnection.ip}
    />;
}, (prevProps, nextProps) =>
        prevProps.vpnStatus === nextProps.vpnStatus &&
        prevProps.supportConnection === nextProps.supportConnection
);
